// Shared, pluggable field validators.
// Each validator takes the raw value plus an options object (currently just
// `label`, used to build a readable message) and returns an error string,
// or an empty string when the value is valid. This lets EditableField (and
// any future form) reuse the same rules by field "type" instead of each
// screen writing its own ad-hoc checks.

// Same pattern already used in New_signup.js, kept consistent here.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[0-9]{10}$/;

export const validators = {
    text: (value, { label = "This field", required = true } = {}) => {
        const trimmed = (value ?? "").toString().trim();
        if (required && !trimmed) return `${label} is required.`;
        return "";
    },

    email: (value, { label = "Email", required = true } = {}) => {
        const trimmed = (value ?? "").toString().trim();
        if (!trimmed) return required ? `${label} is required.` : "";
        if (!EMAIL_REGEX.test(trimmed)) return `Please enter a valid ${label.toLowerCase()} address.`;
        return "";
    },

    phone: (value, { label = "Phone number", required = true } = {}) => {
        const trimmed = (value ?? "").toString().trim();
        if (!trimmed) return required ? `${label} is required.` : "";
        if (!PHONE_REGEX.test(trimmed)) return `Please enter a valid 10-digit ${label.toLowerCase()}.`;
        return "";
    },
};

export default validators;
